import { applyMotionPreference } from '@/features/settings/appearance-settings';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/design-system/components/tooltip';
import { queryClient } from '@/lib/query';
import { router } from '@/app/router';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            className: '!bg-overlay !text-fg !border-0 !shadow-float !rounded-panel !font-sans',
          }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);

applyMotionPreference();
try {
  document.documentElement.dataset.density = localStorage.getItem('cw.density') ?? 'normal';
} catch {
  /* sem armazenamento */
}
